import api from "./api";

const route = "/tags";

const TagsService = {
  getTags: () => api.get(route),
};

export default TagsService;